<template>
    <article>
        <form autocomplete="off" class="w-full mb-8">
            <input autocomplete="false" name="hidden" type="text" style="display:none;">
            <!-- Global Notification Preferences -->
            <!-- <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-10 bg-bhav-cool-gray-50 p-5 rounded-lg relative overflow-visible">
                <div class="flex flex-col gap-1 w-full">
                    <label for="notificationType" class="block text-sm font-medium text-bhav-blue-500">
                        Notification Type
                    </label>
                    <SelectField
                        :key="selectKey"
                        id="notificationFrequency"
                        v-model="item.meta.prefs.alerts.emails.frequency"
                        @update:modelValue="handleSelectChange"
                        :allow-null="false"
                        empty="Please Select..."
                        :options="frequencyOptions"
                        class="block w-full appearance-none rounded-lg border border-gray-300 bg-white py-2 px-3 pr-8 text-sm text-gray-900 shadow-sm focus:border-bhav-blue-400 focus:ring focus:ring-bhav-blue-200 focus:ring-opacity-50 cursor-pointer"
                    />

                </div>

                <div class="flex flex-col gap-1 w-full">
                    <label for="notificationFrequency" class="block text-sm font-medium text-bhav-blue-500">
                        Frequency
                    </label>
                    <SelectField
                        :key="selectKey + 1"
                        id="notificationType"
                        v-model="item.meta.prefs.alerts.emails.type"
                        @update:modelValue="handleSelectChange"
                        :allow-null="false"
                        empty="Please Select..."
                        :options="typeOptions"
                        class="block w-full appearance-none rounded-lg border border-gray-300 bg-white py-2 px-3 pr-8 text-sm text-gray-900 shadow-sm focus:border-bhav-blue-400 focus:ring focus:ring-bhav-blue-200 focus:ring-opacity-50 cursor-pointer"
                    />

                </div>
            </div> -->

            <section v-if="filteredNotifications.length > 0" class="flex flex-col gap-2">
                <h3 class="sr-only">My Notifications</h3>
                <div v-for="(notification, index) in filteredNotifications" :key="index" class="w-full">
                    <div class="w-full bg-bhav-cool-gray-50 p-4 rounded-lg flex justify-between items-center">
                        <div class="flex items-center gap-2 mr-2 cursor-pointer" @click="toggleExpanded(index)">
                            <i class="fas fa-xs text-bhav-blue-300" :class="expandedSections[index] ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                        </div>
                        <label class="text-bhav-blue-300 flex-1  text-sm cursor-pointer" @click="toggleExpanded(index)">{{ notification.notifiable?.name }}</label>
                        <div class="flex items-center gap-2 ml-2">
                            <i class="fas fa-trash cursor-pointer text-blue-500 h-4 w-4" @click.stop="deleteNotification(notification)" title="Delete notification"></i>
                        </div>
                    </div>
                    <div v-if="expandedSections[index]" class="w-full mt-2">
                        <ul class="px-3 border-l border-l-bhav-blue-50 ml-6">
                            <li v-for="option in availableOptions(notification)" :key="option.key" class="flex items-center justify-between py-3 w-full gap-3">
                                <label :for="`option-${option.key}`" class="text-sm font-medium text-bhav-blue-500 cursor-pointer flex-1">{{ option.label ?? 'Nothing' }}</label>
                                <input :id="`option-${option.key}`" type="checkbox" :checked="option.enabled" @change="toggle(notification, option.key, !option.enabled)" class="appearance-none text-bhav-blue-400 bg-bhav-cool-gray-50 hover:bg-white rounded-lg flex h-6 w-6 min-w-6 min-h-6 p-1 items-center justify-center cursor-pointer flex-0" :class="{'fak fa-check' : option.enabled}" />
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <div class="px-4 text-center text-blue-500 text-sm mt-8" v-else>
                No Subscriptions
            </div>

            <!-- New Notification Component -->
            <NewNotification
                :open="showNewNotification"
                :userId="id"
                :notifications="notifications"
                @notification-created="handleNotificationCreated"
                @cancel="showNewNotification = false"
            />
        </form>
    </article>
</template>

<script>
import axios from 'axios';
import { SelectField } from '@/components/form';
import { useMessageStore } from '@/stores/message';
import { mapState } from 'pinia';
import User from '@/models/user';
import NotificationSettingTypes from '@/enums/NotificationSettingTypes';
import NotificationFrequencies from '@/enums/NotificationFrequencies';
import NotificationTypes from '@/enums/NotificationTypes';
import { NotificationsController } from '@/controllers/notifications';
import NewNotification from '@/components/NewNotification.vue';

export default {
    setup() {
        const messageStore = useMessageStore();
        return {
            NotificationSettingTypes,
            NotificationFrequencies,
            NotificationTypes,
            messageStore
        }
    },
    props: {
        id: {
            type: [Number, null],
            required: false,
            default: null
        },
        profile: {
            type: Boolean,
            required: false,
            default: false
        },
        item: {
            type: Object,
            required: false,
            default: () => new User
        },
        loading: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            notifications: [],
            expandedSections: {},
            showNewNotification: false,
            selectKey: 0,
            typeOptions: [
                { label: "Email + In App", value: "email_and_app" },
                { label: "Email Only", value: "email_only" },
                { label: "In App Only", value: "app_only" }
            ],
            frequencyOptions: [
                { label: "Hourly", value: "Hourly" },
                { label: "Daily", value: "Daily" },
                { label: "Weekly", value: "Weekly" }
            ],

            notificationType: "email_and_app",
            notificationFrequency: "Daily"
        }
    },
    methods: {
        // handleSelectChange() {
        //     this.selectKey++;
        // },
        availableOptions(notification) {
            const allowedMeta = NotificationTypes.getAllowedMeta(NotificationTypes.DIVISION)
            const allTypes = NotificationTypes.getAllTypes()

            // Create options map for all types including 'self'
            const allOptions = {}
            allTypes.forEach(type => {
                const key = type.key
                allOptions[key] = {
                key,
                label: type.label
                }
            });

            const returnn = allowedMeta.map(key => ({
                ...allOptions[key],
                enabled: notification?.meta?.[key] || false
            }));

            return returnn;
        },
        toggleExpanded(index) {
            this.expandedSections = {
                ...this.expandedSections,
                [index]: !this.expandedSections[index]
            }
        },
        handleNotificationCreated(newNotification) {
            // Hide the new notification component
            this.showNewNotification = false;
            // Reload notifications to get the latest data with relationships
            this.load();
        },
        showNewNotificationForm() {
            this.showNewNotification = true;
        },
        toggle(notification, key, enabled) {
            if (notification) {
                // Store the original notifiable data before update
                const originalNotifiable = notification.notifiable;

                // Update the notification meta
                if (!notification.meta) {
                    notification.meta = {};
                }
                notification.meta[key] = enabled;

                // Use NotificationsController to update
                NotificationsController.update(notification)
                    .then(updatedNotification => {
                        // Preserve the original notifiable data if missing from response
                        if (originalNotifiable) {
                            updatedNotification.notifiable = originalNotifiable;
                        }

                        // Update the local notification with the response
                        const index = this.notifications.findIndex(n => n.id === notification.id);
                        if (index !== -1) {
                            this.notifications[index] = updatedNotification;
                        }
                    })
                    .catch(error => {
                        console.error('Error updating notification:', error);
                        this.messageStore.setAlert({
                            text: 'Failed to update notification settings',
                            level: 'error'
                        });
                    });
            }
        },
        deleteNotification(notification) {
            if (notification) {
                NotificationsController.delete(notification)
                    .then(() => {
                        // Update the local notification in the array
                        const index = this.notifications.findIndex(n => n.id === notification.id);
                        if (index !== -1) {
                            // Create a new notification object with updated deleted_at
                            this.notifications[index] = {
                                ...this.notifications[index],
                                deleted_at: new Date().toISOString()
                            };
                        }

                    })
                    .catch(error => {
                        console.error('Error deleting notification:', error);
                        this.messageStore.setAlert({
                            text: 'Failed to delete notification',
                            level: 'error'
                        });
                    });
            }
        },
        load() {
            try {
                NotificationsController.index(undefined, undefined)
                .then(resp => {
                    this.notifications = resp
                });
            } finally {
            }
        },
        // updateUserPreferences() {
        //     if (this.id && this.item) {
        //         let data = {
        //             prefs: this.item.meta.prefs,
        //         };

        //         axios.patch(`users/${this.id}/preferences`, data)
        //             .then((resp) => {
        //             })
        //             .catch(err => {
        //                 console.error('Error updating notification preferences:', err);
        //                 this.messageStore.setAlert({
        //                     text: 'Failed to update notification preferences',
        //                     level: 'error'
        //                 });
        //             });
        //     }
        // },

        // async updateUserNotificationPrefs() {
        //     if (!this.id || !this.item) return;

        //     try {
        //         await axios.patch(`users/${this.id}/preferences`, {
        //         prefs: this.item.meta.prefs
        //         });

        //         this.messageStore.setAlert({
        //         text: "Notification preferences updated successfully!",
        //         level: "success"
        //         });
        //     } catch (err) {
        //         console.error("Error updating notification preferences:", err);
        //         this.messageStore.setAlert({
        //         text: "Failed to update notification preferences",
        //         level: "error"
        //         });
        //     }
        // },

        // handleChange() {
        //     this.$emit('update:modelValue', this.model);
        //     this.$nextTick(() => {
        //         const el = this.$el.querySelector('select');
        //         if (el && document.activeElement === el) {
        //             el.blur();
        //         }
        //     });
        // },

    },
    // watch: {
    //     'item.meta.prefs.alerts.emails.type'() {
    //         this.updateUserNotificationPrefs();
    //     },
    //     'item.meta.prefs.alerts.emails.frequency'() {
    //         this.updateUserNotificationPrefs();
    //     }
    // },
    computed: {
        ...mapState(useMessageStore, ['setAlert']),
        filteredNotifications() {
            return this.notifications
            .filter(notification => notification.active)
            .sort((a, b) => {
                return (a.notifiable?.name || '').toLowerCase()
                .localeCompare((b.notifiable?.name || '').toLowerCase());
            });
        }
    },
    mounted() {
        this.load();

        // this.item.meta = this.item.meta || {};
        // this.item.meta.prefs = this.item.meta.prefs || {};
        // this.item.meta.prefs.alerts = this.item.meta.prefs.alerts || {};
        // this.item.meta.prefs.alerts.emails = this.item.meta.prefs.alerts.emails || {
        //     type: "email_and_app",
        //     frequency: "Daily"
        // };
    },
    components: {
        SelectField, NewNotification
    }
}
</script>